import React from 'react';

/**
 * Skeleton de la portada: panel de estadísticas + dos tarjetas (bloques y productores),
 * para no dar un salto de layout al cambiar de blockchain.
 */
const LoadingState = () => {
  const rows = (n) => [...Array(n)].map((_, i) => (
    <div key={i} className="flex items-center gap-4 px-5 py-4 border-b border-gray-100">
      <div className="h-3 w-6 bg-gray-200 rounded" />
      <div className="h-3 w-32 bg-gray-200 rounded" />
      <div className="ml-auto h-3 w-20 bg-gray-100 rounded" />
    </div>
  ));

  return (
    <div className="flex flex-col gap-6 animate-pulse" aria-busy="true" aria-label="Loading">
      <div className="card flex flex-wrap">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex-[1_1_260px] px-6 py-5 space-y-3">
            <div className="h-3 w-20 bg-gray-200 rounded" />
            <div className="h-4 w-28 bg-gray-200 rounded" />
            <div className="h-3 w-20 bg-gray-100 rounded mt-4" />
            <div className="h-4 w-24 bg-gray-100 rounded" />
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card"><div className="card-header"><div className="h-4 w-32 bg-gray-200 rounded" /></div>{rows(6)}</div>
        <div className="card"><div className="card-header"><div className="h-4 w-40 bg-gray-200 rounded" /></div>{rows(6)}</div>
      </div>
    </div>
  );
};

export default LoadingState;
